import React from "react";
import styled from "styled-components";
import moment from "moment";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby";
import logo from "../assets/trustflight-logo-blue.svg";
import TwitterLogo from "../assets/twitter.svg";
import LILogo from "../assets/linkedin.svg";
import CanadaFlag from "../assets/icon-flag-ca.svg";
import UKFlag from "../assets/icon-flag-uk.svg";
import USFlag from "../assets/icon-flag-us.svg";
import FSF_logo from "../assets/FSF_logo.png";
import NBAA_logo from "../assets/NBAA_logo.png";
import * as styles from "./footer.module.less";

const aboutListContent = [
  { name: "About TrustFlight", link: "about" },
  { name: "Technology", link: "technology" },
  { name: "News", link: "news" },
  { name: "Case Studies", link: "case-studies" },
  { name: "Careers", link: "careers" },
  { name: "Culture", link: "culture" },
  { name: "Legal", link: "legal" },
  { name: "Terms & Conditions", link: "terms" },
  { name: "Modern Slavery Policy", link: "modern-slavery" },
];

const productListContent = [
  { name: "Tech Log", link: "techlog" },
  { name: "SMS/QMS", link: "centrik" },
  { name: "MEL Manager", link: "mel-manager" },
  { name: "Smart Regulations", link: "smartregs" },
  { name: "Reliability Analytics", link: "reliability-analytics" },
];

const servicesListContent = [
  { name: "Continuing Airworthiness", link: "services" },
  { name: "Training", link: "training" },
  { name: "AOC Services", link: "services", state: "AOC" },
  { name: "Document Publishing", link: "services", state: "doc" },
  { name: "Fleet Asset Management", link: "services", state: "fleet" },
];

const listCreator = (array) => {
  const list = array.map((item) => {
    return (
      <Link
        className={styles.footerLink}
        to={`/${item.link}/`}
        key={item.name}
        state={{ from: item.state }}
      >
        {item.name}
      </Link>
    );
  });
  return <div className={styles.footerList}>{list}</div>;
};

const StyledDiv = styled("div")`
  width: 100%;
  background-image: linear-gradient(to bottom, #f8fcff 0%, #ffffff);
  border-top: 1px #ecf1f6 solid;
`;

const Header = styled("h3")`
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.06px;
  color: #242d41;
  margin-bottom: 20px;
  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

const FinalText = styled("span")`
  opacity: 0.7;
  font-family: Open Sans;
  font-size: 12px;
  line-height: 2;
  letter-spacing: 0.05px;
  color: rgba(36, 45, 65, 0.8);
`;

const StyledContentDiv = styled("div")`
  margin: 0;
`;

const StyledImg = styled("img")`
  margin-right: 30px;
`;

const Flag = styled.img`
  height: 30px;
  width: 30px;
  margin-right: 8px;
`;

const MailingDiv = styled.div``;

const Button = styled.div`
  border-radius: 21px;
  border: solid 2px #1e5bb5;
  background-color: #1e5bb5;
  color: #ffffff;
  font-size: 14px;
  padding: 2px 14px;
  margin-top: 1rem;
  width: 140px;
  text-align: center;
`;

const FooterLink = styled.a`
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 2.49;
  letter-spacing: 0.05px;
  color: rgba(36, 45, 65, 0.8);
  margin: 0;
  word-break: keep-all;
  transition: all 0.4s;
  &:hover {
    text-decoration: none;
    color: #1e5bb5;
  }
`;

const SafetyLogoContentContainer = styled.div`
  display: flex;
  align-items: center; /* This ensures the images are aligned in the middle vertically */
  margin-top: 20px;
  max-width: 150px;
  img {
    max-height: 50px;
    margin-right: 15px; /* Adds some space between the images */
  }
  img:last-child {
    margin-right: 0; /* Removes the margin from the last image */
  }
`;
const Footer = ({ noNavigation }) => {
  return (
    <StyledDiv>
      <Container>
        <Row className={`${styles.innerStyleDiv} justify-content-md-center`}>
          <Col xl={12}>
            {!noNavigation ? (
              <Row className={styles.infoDiv}>
                <Col lg={3} md={12}>
                  <div className={styles.imageDiv}>
                    <img src={logo} alt="footerlogo" />
                  </div>
                </Col>
                <Col lg={2} md={4} xs={6}>
                  <StyledContentDiv>
                    <Header>About</Header>
                    {listCreator(aboutListContent)}
                  </StyledContentDiv>
                </Col>
                <Col lg={3} md={4} xs={6}>
                  <StyledContentDiv>
                    <Header>Products</Header>
                    {listCreator(productListContent)}
                    <Header>Services</Header>
                    {listCreator(servicesListContent)}
                  </StyledContentDiv>
                </Col>
                <Col lg={{ span: 3, offset: 0 }} md={{ span: 4 }}>
                  <StyledContentDiv>
                    <Header>Contact details</Header>
                    <div>
                      <Flag src={USFlag} />
                      <FooterLink href="tel:+18447849836">
                        +1 (844) 784-9836
                      </FooterLink>
                    </div>
                    <div>
                      <Flag src={UKFlag} />
                      <FooterLink href="tel:+443302290219">
                        +44 (0) 330 229 0219
                      </FooterLink>
                    </div>
                    <div>
                      <Flag src={CanadaFlag} />
                      <FooterLink href="tel:+18447849836">
                        +1 (844) 784-9836
                      </FooterLink>
                    </div>
                    <MailingDiv>
                      <FooterLink href="mailto:info@trustflight.com">
                        info@trustflight.com
                      </FooterLink>
                    </MailingDiv>
                    <Link to="/contact/">
                      <Button>Get in touch</Button>
                    </Link>
                  </StyledContentDiv>
                  <SafetyLogoContentContainer>
                    <img
                      src={FSF_logo}
                      alt="Flight Safety Foundation Member"
                      aria-hidden="true"
                    />
                    <img
                      src={NBAA_logo}
                      alt="NBAA (National Business Aviation Association) Member"
                      aria-hidden="true"
                    />
                  </SafetyLogoContentContainer>
                </Col>
              </Row>
            ) : null}
            <Row className="justify-content-md-center">
              <Col md={12} className={styles.finalInfo}>
                <div>
                  <FinalText>© {moment().format("YYYY")} TrustFlight</FinalText>
                </div>
                <div>
                  <a
                    href="https://twitter.com/trustflight"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.socialLink}
                  >
                    <StyledImg src={TwitterLogo} alt="twitter logo" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/trustflight/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.socialLink}
                  >
                    <StyledImg src={LILogo} alt="linkedin logo" />
                  </a>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </StyledDiv>
  );
};

export default Footer;
